var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2043_13737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6511 11.4416C35.6837 12.3707 35.1168 13.7287 34.1617 14.9639C31.2399 18.7454 31.2424 20.9823 34.1483 24.7539C36.5802 27.9106 36.0073 32.1371 32.8321 34.466C29.8617 36.6444 25.7834 35.9051 23.5154 32.7784C21.7944 30.406 21.9692 27.0986 24.0223 24.5941C24.8049 23.6391 25.5668 22.7034 25.8452 21.4698C26.4624 18.7346 25.4782 16.1003 23.2931 14.6386C21.072 13.1534 18.3892 13.2629 16.0377 14.9505C15.572 15.285 15.1522 15.6847 14.6881 16.0217C11.7612 18.1466 8.15612 17.7762 5.74689 15.1136C3.44386 12.568 3.43383 8.88937 5.7218 6.28697C7.93869 3.76652 11.6675 3.31495 14.5099 5.2517C15.2792 5.77602 15.9466 6.45841 16.741 6.93422C19.0976 8.34748 21.6657 7.97786 24.2957 5.92989C27.0495 3.78575 29.7731 3.40108 32.2709 4.91218C34.4553 6.23346 35.6319 8.18859 35.6511 11.4416Z",
    fill: "#FC6524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4243 29.1516C17.3699 32.7366 14.1312 35.8073 10.5244 35.6928C6.957 35.5799 4.0109 32.551 4.00003 28.9852C3.98916 25.3576 7.10418 22.317 10.7887 22.3588C14.4532 22.4006 17.4795 25.4981 17.4243 29.1516Z",
    fill: "#FC6524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2043_13737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.91123b1aa0c8573aac9936e17942f4ba.svg";
export { ForwardRef as ReactComponent };